/** GCGR staff and line-item payloads, flattened for the workbook. */
import { GCGR, GCGRLineItem, StaffDetail } from "../../interfaces/GCGRs";

export const transformStaffDetails = (
  staffing: StaffDetail[],
  phases: Record<string, any>[],
  employees: Record<string, any>[],
  positions: Record<string, any>[],
  gcgr: GCGR
): Record<string, any>[] =>
  staffing.map((staff: StaffDetail) => ({
    position_name: staff.position_name,
    employee_name: employees.find((emp: Record<string, any>) => emp.id === staff.employee)?.name ?? "",
    salary: staff.salary,
    car_allowance: staff.car_annual_allowance,
    rate: staff.rate,
    grand_total: staff.grand_total,
    phase: phases.find((ph: Record<string, any>) => ph.id === staff.phase)?.name ?? "",
    phase_category: phases.find((ph: Record<string, any>) => ph.id === staff.phase)?.category ?? "",
    start_date: staff.allocations.start_date,
    finish_date: staff.allocations.finish_date,
    allocation: staff.allocations.average_allocation,
    duration:
      (Date.parse(staff.allocations.finish_date) - Date.parse(staff.allocations.start_date)) / 1000 / 60 / 60 / 168, // in weeks , 168 is total hrs / wk
    cost_code: positions.find((pos: Record<string, any>) => pos.id === staff.position)?.cost_code ?? "",
    multiplier:
      staff.rates.multiplier ??
      (positions.find((pos: Record<string, any>) => pos.id === staff.position)?.type === "estimator"
        ? gcgr.estimating_multiplier
        : gcgr.construction_multiplier),
    labor_total: staff.rates.laborTotal,
    id: staff.id,
    sort_order: staff.sort_order,
  }));

export const transformGcgrLineItems = (
  lineItems: GCGRLineItem[],
  groups: Record<string, any>[]
): Record<string, any>[] =>
  lineItems.map((lineItem: GCGRLineItem) => ({
    name: lineItem.name,
    quantity: lineItem.quantity,
    uom: lineItem.uom,
    total_uc: lineItem.total_uc,
    total: lineItem.total_cost_text ? lineItem.total_cost_text : lineItem.total_cost,
    group: groups.find((group: Record<string, any>) => group.id === lineItem.group)?.name ?? "",
    type: lineItem.type,
    reporting_type: lineItem.reporting_type,
    cost_code: lineItem.cost_code,
    product: lineItem.product,
    order: lineItem.order,
    id: lineItem.id,
  }));
